import { render, staticRenderFns } from "./UserFormInfo.vue?vue&type=template&id=e62187fe&scoped=true"
import script from "./UserFormInfo.vue?vue&type=script&lang=js"
export * from "./UserFormInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62187fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e62187fe')) {
      api.createRecord('e62187fe', component.options)
    } else {
      api.reload('e62187fe', component.options)
    }
    module.hot.accept("./UserFormInfo.vue?vue&type=template&id=e62187fe&scoped=true", function () {
      api.rerender('e62187fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UserFormInfo.vue"
export default component.exports